import React from 'react';
import styled from 'styled-components';

interface ResetButtonProps {
  onClick: () => void;
}

const StyledButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 20px;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #f44336;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  &:hover {
    background-color: #d32f2f;
  }
`;

const ResetButton: React.FC<ResetButtonProps> = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick} title="すべてのカードを削除">
      リセット
    </StyledButton>
  );
};

export default ResetButton; 